import React, {useEffect} from 'react';
import HeroSection from '../sections/heroSection';
import Statistics from '../sections/statistics';
import TextWithImage from '../sections/textWithImage';
import Carousal from '../components/carousal';
import CareerForm from '../sections/career-form';

const Careers = () => {
    const body = document.body;
    body.classList = 'template-careers'; 
    const content = require('../jsons/careers.js').default;
     
    const scrollToCareerForm = (e) => {
        e.preventDefault()
        var careerForm = document.getElementsByClassName('careerForm')[0];  
        window.scrollTo({top: careerForm.offsetTop-80,left: 0,behavior: 'smooth'});
    }
    
    useEffect(() =>{
        var applyJob = document.getElementsByClassName('apply-job')[0];
        applyJob.addEventListener('click', scrollToCareerForm);
        return () =>{
            applyJob.removeEventListener('click', scrollToCareerForm);
        }
    });

    return(
        <div className="innerWrapper">            
             {content.heroSection && 
                <HeroSection data={ content.heroSection }/>
            } 
            {content.statistics && 
                <Statistics data={ content.statistics}/>
            } 
            <div className="sections whiteBg">
                {content.textWithImage && 
                    <TextWithImage data={content.textWithImage} />
                } 
                {content.carousal && 
                    <Carousal data={content.carousal} />
                } 
                <CareerForm />                      
            </div>            
        </div>
    )
}

export default Careers;